module.exports = __webpack_public_path__ + "img/selected5-min.195eb503.png";